import * as React from 'react';
import localeService from 'src/dataServices/LocaleService';
import './CopilotDisclaimer.scss';

export const CopilotDisclaimer: React.FC = () => {
  const termsOfUseUrl = process.env.REACT_APP_TERMS_OF_USE_URL || 'https://www.microsoft.com/servicesagreement';
  const privacyUrl = process.env.REACT_APP_PRIVACY_URL || 'https://aka.ms/privacystatement';

  return (
    <div className="copilot-disclaimer">
      <div className="copilot-disclaimer-text">{localeService.getText('ContactUs', 'CopilotDisclaimerText')}</div>
      <div className="copilot-disclaimer-links">
        <a href={termsOfUseUrl} target="_blank" rel="noopener noreferrer">
          {localeService.getText('ContactUs', 'CopilotDisclaimerTermsOfUse')}
        </a>
        {' | '}
        <a href={privacyUrl} target="_blank" rel="noopener noreferrer">
          {localeService.getText('ContactUs', 'CopilotDisclaimerPrivacy')}
        </a>
      </div>
    </div>
  );
};

